
import { AfterViewInit, ComponentRef, Directive, ElementRef, Input, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { LoaderOutletComponent } from './loader-outlet.component';

@Directive({
    selector: '[ssCoreLoaderOutlet]'
})
export class LoaderOutletDirective implements AfterViewInit {
    private readonly _destroy = new Subject<void>()

    readonly keySubject = new BehaviorSubject<string[]>(undefined)
    @Input() get keys() {
        return this.keySubject.value;
    }
    set keys(value) {
        this.keySubject.next(value)
    }

    readonly diameterSubject = new BehaviorSubject<number>(50);
    @Input() get diameter() {
        return this.diameterSubject.value;
    }
    set diameter(value) {
        this.diameterSubject.next(value)
    }

    readonly heightSubject = new BehaviorSubject<string>('100%')
    @Input() get height() {
        return this.heightSubject.value
    }
    set height(value) {
        this.heightSubject.next(value)
    }

    private _componentRef: ComponentRef<LoaderOutletComponent>;
    constructor(
        private readonly _elementRef: ElementRef<HTMLDivElement>,
        private readonly _viewContainerRef: ViewContainerRef
    ) {

    }

    private _prevHeight: string

    ngAfterViewInit(): void {
        this._componentRef = this._viewContainerRef.createComponent(LoaderOutletComponent);

        this._elementRef.nativeElement.appendChild(this._componentRef.location.nativeElement);
        this._elementRef.nativeElement.style.position = 'relative';

        this.diameterSubject
            .pipe(takeUntil(this._destroy))
            .subscribe((diameter) => {
                this._componentRef.instance.diameter = diameter;
            })

        this.keySubject
            .pipe(takeUntil(this._destroy))
            .subscribe((keys) => {
                this._componentRef.instance.keys = keys;
            })


        this.heightSubject.pipe(takeUntil(this._destroy))
            .subscribe((height) => {
                this._componentRef.instance.height = height;
            })


    }


    ngOnDestroy() {
        this._destroy.next()
        this._destroy.complete()
    }

}
